module.exports = __webpack_public_path__ + "img/des_happy_3.9232b7b8.jpg";